<template>
  <v-tooltip bottom :disabled="!showTooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        v-if="userId && userName"
        :size="size"
        :color="color"
        class="white--text font-weight-medium user-avatar"
        v-bind="attrs"
        v-on="on"
      >
        {{ userInitials }}
      </v-avatar>
    </template>
    <span>{{ userName }}</span>
  </v-tooltip>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'UserAvatar',
  props: {
    userId: {
      type: String,
      required: true
    },
    size: {
      type: [String, Number],
      default: 32
    },
    color: {
      type: String,
      default: 'primary'
    },
    showTooltip: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      company_users: state => state.user.company_users,
    }),
    userName() {
      if (!this.userId) return '';
      // Fulfillments made from the Shopify admin (admin UI extension) carry the staff id, not an app user
      if (this.userId.startsWith('shopify:')) return 'Shopify admin';
      if (!this.company_users) return '';
      const user = this.company_users.find(u => u.id === this.userId);
      return user ? user.name : '';
    },
    userInitials() {
      if (!this.userName) return '';
      const names = this.userName.trim().split(' ');
      if (names.length === 1) {
        return names[0].charAt(0).toUpperCase();
      }
      return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
    }
  }
}
</script>

<style lang="scss" scoped>
.user-avatar {
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
}
</style>
